import { TProductBEItem } from 'api/products/products.types';
import { TStockItem } from 'api/stock/stock.types';
import { TPhoneCasesAvailability } from 'screens/ProductPage/ProductPage.types';
import { TLocalCartItem } from 'store/localCart';

export const checkCartStockFulfillment = (
  cartItemsStock: Record<TStockItem['id'], number>,
  stockItemsVocabulary: Record<TStockItem['id'], TStockItem>
): boolean => {
  for (const idKey in cartItemsStock) {
    const cartItemStock = cartItemsStock[idKey];
    const stockItemVocabulary = stockItemsVocabulary[idKey]?.quantity;
    if (cartItemStock > stockItemVocabulary) {
      return false;
    }
  }
  return true;
};

export const getMissingStockItems = (
  cartItemsStock: Record<TStockItem['id'], number>,
  stockItemsVocabulary: Record<TStockItem['id'], TStockItem>
): Record<TStockItem['id'], TStockItem> =>
  Object.entries(cartItemsStock).reduce<Record<TStockItem['id'], TStockItem>>(
    (acc, [id, requiredQty]) => {
      if (requiredQty > stockItemsVocabulary[id]?.quantity) {
        acc[id] = stockItemsVocabulary[id];
      }
      return acc;
    },
    {}
  );

export const hasMissingStockItems = (
  cartItemStock: Array<{ stockItem: TStockItem; quantity: number }>,
  stockItemsMissingVocabulary: Record<TStockItem['id'], TStockItem>
): boolean => {
  for (const stockItem of cartItemStock) {
    const hasMissingStockItem =
      !!stockItemsMissingVocabulary[stockItem.stockItem?.id];
    if (hasMissingStockItem) {
      return true;
    }
  }
  return false;
};

export const hasMissingVariation = (
  phoneCasesAvailability: TPhoneCasesAvailability,
  selectedPhoneModel: string,
  variationName: string
) => {
  return !phoneCasesAvailability?.variationsStock?.[selectedPhoneModel]?.[
    variationName
  ]?.quantity;
};

export const getProductFullPrice = (product: TProductBEItem) => {
  return product.newPrice ? product.newPrice : product.price;
};

export const getOutdatedPricesProducts = (
  cartItems: TLocalCartItem[],
  products: Map<string, TProductBEItem>
) => {
  return cartItems.reduce<
    Array<{ id: string; price: number; productName: string }>
  >((acc, cartItem) => {
    const checkProduct = products.get(cartItem.productId);

    if (checkProduct && getProductFullPrice(checkProduct) !== cartItem.price) {
      acc.push({
        id: cartItem.id,
        price: getProductFullPrice(checkProduct),
        productName: checkProduct.name,
      });
    }
    return acc;
  }, []);
};
